import React from "react";
import { BsApple, BsGooglePlay } from "react-icons/bs";

import EduLawIcon from "./asset/edulaw_icon_1024.png";

function MaintenancePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "#f8f9fb",
      }}
    >
      <div
        style={{
          maxWidth: 680,
          width: "100%",
          textAlign: "center",
        }}
      >

        {/* Logo */}
        <img
          src={EduLawIcon}
          alt="EduLaw"
          style={{
            width: 130,
            height: 130,
            borderRadius: 28,
            marginBottom: 28,
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          }}
        />

        {/* Title */}
        <h5
          style={{
            fontSize: 42,
            fontWeight: "bold",
            marginBottom: 18,
            color: "#1f2937",
            fontFamily: "Kanit",
          }}
        >
          เว็บไซต์ EduLaw Books <br/>กำลังปิดปรับปรุง
        </h5>

        {/* Divider */}
        <div
          style={{
            width: 90,
            height: 2,
            background: "#d1d5db",
            margin: "0 auto 28px auto",
            borderRadius: 999,
          }}
        />

        {/* Description */}
        <p
          style={{
            fontSize: 20,
            color: "#6b7280",
            lineHeight: 1.8,
            marginBottom: 42,
            fontFamily: "Kanit",
          }}
        >
          ขออภัยในความไม่สะดวก
          พบกับสิ่งที่น่าสนใจเร็วๆนี้
        </p>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 18,
            flexWrap: "wrap",
          }}
        >

          {/* iOS */}
          <a
            href="https://apps.apple.com/th/app/edulaw/id6503618185?l=th"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "16px 28px",
              border: "1.5px solid #d1d5db",
              borderRadius: 16,
              textDecoration: "none",
              color: "#111827",
              background: "#fff",
              fontSize: 20,
              fontWeight: "600",
              minWidth: 180,
              justifyContent: "center",
              transition: "0.2s",
              fontFamily: "Kanit",
            }}
          >
            <BsApple size={28} />
            iOS
          </a>

          {/* Android */}
          <a
            href="https://play.google.com/store/apps/details?id=com.testrn02&hl=th"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "16px 28px",
              border: "1.5px solid #d1d5db",
              borderRadius: 16,
              textDecoration: "none",
              color: "#111827",
              background: "#fff",
              fontSize: 20,
              fontWeight: "600",
              minWidth: 220,
              justifyContent: "center",
              transition: "0.2s",
              fontFamily: "Kanit",
            }}
          >
            <BsGooglePlay size={24} />
            Play Store
          </a>

        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;